import { Link } from "react-router-dom";
import PageHero from "@/components/base/PageHero";
import ScrollReveal from "@/components/base/ScrollReveal";
import CompanySubNav from "@/pages/company/components/CompanySubNav";
import { COMPANY_CHILDREN } from "@/constants/site";

export default function CompanyIndex() {
  return (
    <div className="w-full bg-background-50">
      <PageHero en="COMPANY" ja="企業情報" crumbs={[{ label: "企業情報" }]} />
      <CompanySubNav />

      <section className="w-full py-20 md:py-28">
        <div className="mx-auto w-full max-w-7xl px-6 md:px-12 lg:px-20">
          <ScrollReveal>
            <span className="font-label text-xs tracking-[0.4em] text-secondary-500">
              CORPORATE INFORMATION
            </span>
            <h2 className="mt-6 font-display text-3xl font-light leading-[1.7] tracking-[0.04em] text-foreground-950 md:text-4xl">
              REVRA Groupについて
            </h2>
            <div className="mt-8 flex max-w-2xl flex-col gap-6 font-body text-[15px] leading-[2.1] text-foreground-700">
              <p>
                REVRA Groupは、Revolution（変革）とEra（時代）を掛け合わせた名を持つビジネスグループです。
                事業の成功そのものではなく、一人ひとりの可能性が花開く社会を創ることを使命としています。
              </p>
              <p>
                私たちの想いや理念、会社の輪郭をご紹介します。
                詳しくは、以下の各ページをご覧ください。
              </p>
            </div>
          </ScrollReveal>

          <div className="mt-16 flex flex-col border-t border-background-300/70">
            {COMPANY_CHILDREN.map((child, index) => (
              <ScrollReveal key={child.path} delay={index * 70}>
                <Link
                  to={child.path}
                  className="group flex items-center justify-between border-b border-background-300/70 py-7 transition-colors hover:bg-background-100 md:py-9"
                >
                  <div className="flex items-baseline gap-6 md:gap-10">
                    <span className="font-label text-xs tracking-[0.24em] text-secondary-500">
                      0{index + 1}
                    </span>
                    <span className="font-heading text-lg tracking-[0.04em] text-foreground-950 md:text-xl">
                      {child.label}
                    </span>
                  </div>
                  <div className="flex items-center gap-6">
                    <span className="hidden font-label text-sm tracking-[0.24em] text-foreground-500 md:block">
                      {child.en}
                    </span>
                    <i className="ri-arrow-right-line text-lg text-foreground-950 transition-transform duration-300 group-hover:translate-x-1" />
                  </div>
                </Link>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}